import { GeofencesService } from '../services/geofences-service';
import { MarpolModelBase } from './marpol-zones-model';
import { ZoneFeature } from './zones-base-interfaces';
import { IndexedDBService } from '../../indexed-db/services/db_service';
import { isOnline } from '../utils/helpers';

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;

export class MarpolModelImpl extends MarpolModelBase {
    async getMarpolZones(): Promise<ZoneFeature[] | null> {
        await this.fetchMarpolZones();

        const marpol = this._zones
        return marpol;
    }

    constructor(geojson?: ZoneFeature[]) {
        super();

        if (geojson) {
            this._zones = geojson;
        } else {
            setInterval(() => this.fetchMarpolZones(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _zones: ZoneFeature[] | null = null;

    private async fetchMarpolZones() {
        try {
            if (isVesselOnCloud && !isOnline()) {
                const cached = await IndexedDBService.zones.getByType('MAR_POL');
                if (cached) {
                    this._zones = cached;
                }
                return;
            }
            const zones : ZoneFeature[] = await GeofencesService.fetchGeofenceByZone('MAR_POL');
            if (zones) {
                this._zones = zones;
                await IndexedDBService.zones.save('MAR_POL', zones);
            }
        } catch (error) {
            console.warn('Failed to fetch MAR_POL zones from API, falling back to IndexedDB', error);
            const cached = await IndexedDBService.zones.getByType('MAR_POL');
            if (cached) {
                this._zones = cached;
            }
        }
    }
}
